/* eslint-disable import/no-cycle */
// import { Link } from 'react-router-dom'
// import { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
import { Controller } from 'react-hook-form'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'

import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
import { useUsers } from './useUsers'
import {
  Container,
  // SpanIcon,
  // FilterStatus,
  // SpanFilter,
  // Ul,
} from '../../layouts/LayoutTable/LayoutTable'
// import { FilterIcon } from '../../assets/icons/filter'
// import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { GenericTable } from '../../components/GenericTable/GenericTable'

// import { Button } from '../../components/SideBar/Menu.style'
import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'
import { PlusIcon } from '../../assets/icons/Plus'
import {
  // ButtonIcon,
  ButtonNewUser,
  Div,
  DivInput,
  InputStyle,
  Span,
  // Td,
} from './Users.style'
// import ToggleSwitch from '../../components/Switch/Switch'
// import { Tour } from '../../components/Tour'
// import TourNovoUsuario from '../../utils/JoyRide/tourNovoUsuario'
// import { EditIcon } from '../../assets/icons/EditIcon'
import { SendInvitation } from '../../components/SendInvitation'
import Tooltips from '../../components/Tooltip'
import { BaseEdit, ButtonIcon, FormLogin } from '../UsersAdm/UsersAdm.style'
import ToggleSwitch from '../../components/Switch/Switch'
import { Desativar } from '../../components/Desativar'
import { EditIcon } from '../../assets/icons/EditIcon'
import { EditarUsuarioOrg } from './modal/editarUsuarioOrg'
import { NovoUsuarioOrg } from './modal/novoUsuarioOrg'
// import Tooltips from '../../components/Tooltip'

export function Users() {
  const {
    searchValue,
    setSearchValue,
    // check,
    // setCheck,
    // isShowFilter,
    currentPage,
    setCurrentPage,
    users,
    fetchUsers,
    isLoading,
    handleKeyDown,
    // goToPage,
    // showFilter,
    isShowSend,
    showSend,
    control,
    modalInativar,
    showInativar,
    // statusChecked,
    // statusCheckedTodos,
    // setStatusCheckedFiltro,

    // handleCheckboxChange,
    ativar,
    desativar,

    status,
    setStatus,
    setUserId,
    handleClear,
    fetchUsersOrgId,
    edicao,
    abreFechaEdicao,
    // usersOrgId,
    idUserOrg,

    novoUsuario,
    abreFechaNovoUsuario,
    novoNome,
    setNovoNome,
    novoEmail,
    handleChangeNovoEmail,
    verificaEmailExistente,
    emailJaExiste,
    verificandoEmail,
    novoSenha,
    setNovoSenha,
    novoConfirmarSenha,
    setNovoConfirmarSenha,
    novoPapel,
    setNovoPapel,
    novoCpf,
    setNovoCpf,
    novoCpfs,
    setNovoCpfs,
    novoErro,
    salvandoNovo,
    handleCriaUsuario,
  } = useUsers()

  return (
    <>
      <DivTitle id="saudacaoUsuariosPermissoes" color="black" size={22}>
        <ContainerTitle>
          Usuários e Permissões
          {/* <Tooltips icon={<Tour steps={TourNovoUsuario} />} text="Tour" /> */}
        </ContainerTitle>
      </DivTitle>
      <Container>
        <DivInput>
          <Div>
            <InputStyle
              value={searchValue}
              onChange={event => setSearchValue(event.target.value)}
              onKeyDown={handleKeyDown}
              border={colors.grey300}
              placeholder="Pesquise uma palavra-chave"
              sizeX="264px"
              sizeY="42px"
            />
            <ButtonNewUser
              onClick={abreFechaNovoUsuario}
              id="novoUsuario"
              type="button"
            >
              <PlusIcon /> <h3>Novo usuário</h3>
            </ButtonNewUser>
          </Div>
          <Span onClick={fetchUsers}>
            <SearchIcon />
          </Span>
          {/* <SpanIcon onClick={showFilter}>
            <FilterIcon />
          </SpanIcon> */}
          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={[
                    'Nome',
                    'E-mail',
                    'Nível de acesso',
                    'Ativo',
                    // 'Empresas',
                    // 'Status',
                    'Editar',
                  ]}
                  spacing="40px"
                  font="16px"
                  vendas
                  text
                >
                  {users.content &&
                    users.content.map(user => (
                      <tr className="itemTable" key={user.id}>
                        <td className="colVendas7">{user.nome}</td>
                        <td className="colVendas7">{user.email}</td>
                        <td className="colVendas7">{user.papelOrganizacao}</td>
                        <td className="colAtivaInativa">
                          <Tooltips
                            icon={
                              <FormLogin id="ativoInativo">
                                <Controller
                                  name="isActive"
                                  control={control}
                                  render={({ field: { ref, ...field } }) => (
                                    <ToggleSwitch
                                      adm
                                      checked={user.ativo}
                                      id="status"
                                      // label={statusLabel}
                                      {...field}
                                      onClick={() => {
                                        setUserId(user.id)
                                        setStatus(user.ativo)
                                        showInativar()
                                      }}
                                    />
                                  )}
                                />
                              </FormLogin>
                            }
                            text="Ativar / Desativar"
                          />
                        </td>

                        <td className="col3">
                          <BaseEdit>
                            <ButtonIcon
                              type="button"
                              onClick={() => {
                                fetchUsersOrgId(user.id, user.papelOrganizacao)
                              }}
                            >
                              <EditIcon />
                            </ButtonIcon>
                          </BaseEdit>
                        </td>
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={users.totalElements}
                  offSet={users.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>

        {isShowSend && <SendInvitation closed={showSend} />}
      </Container>
      {edicao && (
        <EditarUsuarioOrg
          modal={() => {
            abreFechaEdicao()
            handleClear()
          }}
          usuarioId={idUserOrg}
        />
      )}
      {novoUsuario && (
        <NovoUsuarioOrg
          modal={abreFechaNovoUsuario}
          nome={novoNome}
          setNome={setNovoNome}
          email={novoEmail}
          onEmailChange={handleChangeNovoEmail}
          onEmailBlur={verificaEmailExistente}
          emailJaExiste={emailJaExiste}
          verificandoEmail={verificandoEmail}
          senha={novoSenha}
          setSenha={setNovoSenha}
          confirmarSenha={novoConfirmarSenha}
          setConfirmarSenha={setNovoConfirmarSenha}
          papel={novoPapel}
          setPapel={setNovoPapel}
          cpf={novoCpf}
          setCpf={setNovoCpf}
          cpfs={novoCpfs}
          setCpfs={setNovoCpfs}
          erro={novoErro}
          salvando={salvandoNovo}
          onSalvar={handleCriaUsuario}
        />
      )}
      {modalInativar && (
        <Desativar
          botaoNao={showInativar}
          botaoSim={status ? desativar : ativar}
          texto={
            status
              ? 'Deseja realmente desativar este usuário?'
              : 'Deseja realmente ativar este usuário?'
          }
        />
      )}
    </>
  )
}
